import { render } from "./issueDetails.vue?vue&type=template&id=976def3e&scoped=true&ts=true"
import script from "./issueDetails.vue?vue&type=script&lang=ts"
export * from "./issueDetails.vue?vue&type=script&lang=ts"

import "./issueDetails.vue?vue&type=style&index=0&id=976def3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-976def3e"]])

export default __exports__